export const MAX_APPROVE_AMOUNT = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';
export const UINT_PSEUDO_UNDEFINED = '115792089237316195423570985008687907853269984665640564039457584007913129639935';
export const MAX_BID_AMOUNT = '115792089237316195423570985008687907853269984665640564039457.584';

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export const ERC_721_INTERFACE_UPGRADEABLE_ID = '0x80ac58cd';
